import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compose, withState, withActions } from "containers/HOC";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import PageTabs, { TAB } from "containers/BudgetHome/PageTabs";
import DrainageDetails from "./DrainageDetails";
import { deleteDrainage, submitDrainage } from "./_actions";
import * as utils from "common/utils";
import { modalInlineClose, modalInlineOpen, confirm } from "containers/App/_actions";

class DrainageEdit extends Component {
    deleteDrainagePrompt() {
        this.props.confirm(`Are you sure you want to delete this drainage system?`, () => this.deleteDrainage());
    }

    deleteDrainage() {
        const budget = this.props.drainageBudget;
        const drainageSystem = budget.drainageSystems.find((d) => d.drainageMethod.toLowerCase() === this.props.drainageMethod.toLowerCase());
        if (!drainageSystem) return;
        /* eslint-disable no-unused-vars */
        for (const drainage of drainageSystem.drainage) {
            /* eslint-disable no-unused-vars */
            for (const block of budget.blocks.filter((b) => b.drainageDetailsId === drainage.id)) {
                block.drainageDetailsId = undefined;
            }
        }
        budget.drainageSystems = budget.drainageSystems.filter((d) => d.drainageMethod.toLowerCase() !== this.props.drainageMethod.toLowerCase());
        this.props.deleteDrainage(this.props.farm.id, budget);
    }

    render() {
        const { farm, drainageBudget } = this.props;
        return (
            <Tile>
                <PageTabs farmId={farm.id} budget={drainageBudget} tab={TAB.WETLANDS} />
                <TileBody>
                    <DrainageDetails farm={farm} budget={this.props.drainageBudget} drainageMethod={this.props.drainageMethod} refData={this.props.refData} location={this.props.location} isNew={false} submit={this.props.submitDrainage} showQuickTips={this.props.showQuickTips} history={this.props.history} modalInlineClose={this.props.modalInlineClose} modalInlineOpen={this.props.modalInlineOpen} deleteDrainagePrompt={() => this.deleteDrainagePrompt()} />
                </TileBody>
            </Tile>
        );
    }
}

export default compose(
    withRouter,
    withState((state, ownProps) => {
        if (!ownProps.budget) return;
        const budget = utils.clone(ownProps.budget);
        const drainageMethod = ownProps.match.params.drainageMethod;
        return {
            ...ownProps,
            refData: state.app.refData,
            drainageBudget: budget,
            drainageMethod: drainageMethod,
        };
    }),
    withActions({ deleteDrainage, submitDrainage, modalInlineClose, modalInlineOpen, confirm })
)(DrainageEdit);
